import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import AppLayout from '../../components/layout/app-layout/app-layout';
import InboxTab from './InboxTab';
import { inboxSides } from './inboxSides';
import { purchaserInboxAdapter } from './purchaserInboxAdapter';
import { salesInboxAdapter } from './salesInboxAdapter';
import { combinedInboxAdapter } from './combinedInboxAdapter';
import styles from './page-inbox.module.scss';

const combinedAdapter = combinedInboxAdapter({ purchaser: purchaserInboxAdapter, sales: salesInboxAdapter });

const PageInbox: FC = () => {
  const [t] = useTranslation('dashboard');
  const sides = inboxSides();
  let inboxTab;

  if (sides.purchaser && sides.sales) {
    inboxTab = <InboxTab key="combined" adapter={combinedAdapter} />;
  } else if (sides.sales) {
    inboxTab = <InboxTab key="sales" adapter={salesInboxAdapter} />;
  } else {
    inboxTab = <InboxTab key="purchaser" adapter={purchaserInboxAdapter} />;
  }

  return (
    <AppLayout title={t('inbox.title', 'Inkorg')}>
      <div className={styles.container}>
        {inboxTab}
      </div>
    </AppLayout>
  );
};

export default PageInbox;
